const renderServicetilesContentStyle = () => {
    const tilesContent = document.querySelectorAll('.tile__content.shorter ');

    if(tilesContent){
        for(let i=0, l=tilesContent.length; i <l; i++){
            const hasDescription= tilesContent[i].querySelector('.tile__description');

            if(hasDescription){
                const tileTitle = tilesContent[i].querySelector('.tile__title'),
                    maxHeight = tileTitle.offsetHeight;

                tilesContent[i].style.maxHeight = maxHeight + "px";
            }
        }
    }
};

renderServicetilesContentStyle();